import axios from "axios";
import cache_util from "./CacheUtil";

// Use environment variable for base URL with production fallback
const IP_PATH =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_BASE_URL_PROD || "http://localhost:1991"
    : process.env.REACT_APP_BASE_URL || "http://localhost:3091";

// Define API options based on environment
const OPTION_API_MAIN = 6;
const OPTION_API_DEFAULT = 4;
const OPTION_API_GROSIR = 7;

function onRequestForm(option_type, route, body_form, listener) {
  const url = getURL(option_type, route);

  // Log the request
  if (process.env.NODE_ENV === "development") {
    console.info(`Making form request to ${route}`, {
      url,
      method: "POST",
      body_form_keys: Object.keys(body_form || {}),
    });
  }

  axios
    .post(url, body_form, {
      headers: getHeaders(),
    })
    .then((res_body) => {
      // Log successful response in development
      if (process.env.NODE_ENV === "development") {
        console.debug("POST request successful", {
          url,
          status: res_body.status,
          statusText: res_body.statusText,
        });
      }

      listener(res_body.data);
    })
    .catch(function (req_error) {
      let res_error = { code: 0, message: req_error.message };
      if (req_error.response !== undefined) {
        res_error = req_error.response.data;
      }

      // Log error response
      console.error("POST request failed", {
        url,
        error: req_error.message,
        response: req_error.response ? req_error.response.data : null,
      });

      listener(res_error);
    });
}

function onRequestData(option_type, route, body, listener) {
  body.view_id = route;
  const options = getOptions(option_type, route, body);

  // Log the request in development
  if (process.env.NODE_ENV === "development") {
    console.info(`Making data request to ${route}`, {
      url: options.url,
      method: options.method,
      body_keys: Object.keys(body || {}),
    });
  }

  axios(options)
    .then(function (res_body) {
      // Log successful response in development
      if (process.env.NODE_ENV === "development") {
        console.debug("Request successful", {
          url: options.url,
          status: res_body.status,
          statusText: res_body.statusText,
        });
      }

      listener(res_body.data);
    })
    .catch(function (req_error) {
      let res_error = { code: 0, message: req_error.message };
      if (req_error.response !== undefined) {
        res_error = req_error.response.data;
      }

      // Log error response
      console.error("Request failed", {
        url: options.url,
        error: req_error.message,
        response: req_error.response ? req_error.response.data : null,
      });

      listener(res_error);
    });
}

function onRequestDataGet(option_type, route, params, listener, extraOptions = {}) {
  const options = getOptionsGet(option_type, route, params, extraOptions);

  // Log the request in development
  if (process.env.NODE_ENV === "development") {
    console.info(`Making GET data request to ${route}`, {
      url: options.url,
      method: options.method,
      params: params,
      responseType: options.responseType || 'default',
    });
  }

  axios(options)
    .then(function (res_body) {
      // Log successful response in development
      if (process.env.NODE_ENV === "development") {
        console.debug("GET request successful", {
          url: options.url,
          status: res_body.status,
          statusText: res_body.statusText,
        });
      }

      listener(res_body.data);
    })
    .catch(function (req_error) {
      let res_error = { code: 0, message: req_error.message };
      if (req_error.response !== undefined) {
        res_error = req_error.response.data;
      }

      // Log error response
      console.error("GET request failed", {
        url: options.url,
        error: req_error.message,
        response: req_error.response ? req_error.response.data : null,
      });

      listener(res_error);
    });
}

function getOptionsGet(option_type, route, params, extraOptions) {
  return {
    method: "get",
    url: getURL(option_type, route),
    params: params,
    headers: getHeaders(),
    ...extraOptions, // 👉 merge opsi tambahan seperti responseType
  };
}

function getOptions(option_type, route, body) {
  return {
    method: "post",
    url: getURL(option_type, route),
    data: body,
    headers: getHeaders(),
  };
}

function getHeaders() {
  let headers = {
    session: cache_util.onGetCacheString(cache_util.CACHE_SESSION),
  };
  let user_information = cache_util.onGetCacheData(cache_util.CACHE_INFO);
  if (user_information !== null) {
    headers.wholesaler = user_information.result.user_information.wholesaler_id;
  }
  return headers;
}

function getURL(option_type, route) {
  // Use environment variables for API URLs based on environment
  const apiBaseUrl =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL;
  // In development mode, use local URLs

  // In production, use the option_type to determine the URL
  switch (option_type) {
    case 2:
      return process.env.REACT_APP_URL_ROUTE_TYPE_OPTION + route;
    case 3:
      return process.env.REACT_APP_URL_ROUTE_TYPE_OPTION + route;
    case 4:
      return process.env.REACT_APP_URL_ROUTE_TYPE_OPTION + route;
    case 5:
      return process.env.REACT_APP_URL_ROUTE_TYPE_OPTION + route;
    case 6:
      return process.env.REACT_APP_URL_ROUTE_TYPE_OPTION + route;
    case 7:
      return process.env.REACT_APP_API_URL_PROD + route;
    default:
      return getURL(OPTION_API_DEFAULT, route); // SEND DEFAULT
  }
}

// Export using ES6 export syntax
export { onRequestData, onRequestForm, onRequestDataGet, IP_PATH, OPTION_API_MAIN, OPTION_API_GROSIR };
